import { render, staticRenderFns } from "./PrizesAdd.vue?vue&type=template&id=28339b51&scoped=true"
import script from "./PrizesAdd.vue?vue&type=script&lang=js"
export * from "./PrizesAdd.vue?vue&type=script&lang=js"
import style0 from "./PrizesAdd.vue?vue&type=style&index=0&id=28339b51&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28339b51",
  null
  
)

export default component.exports